import { CalendarCheck, Scissors, ShoppingCart, User } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useCart } from "../../context/CartContext";

const bottomNavRoutes = [
  {
    label: "Services",
    path: "/services",
    icon: Scissors,
  },
  {
    label: "Bookings",
    path: "/my-bookings",
    icon: CalendarCheck,
  },
  {
    label: "Profile",
    path: "/user-profile",
    icon: User,
  },
  {
    label: "Cart",
    path: "/service-cart",
    icon: ShoppingCart,
    isCart: true,
  },
];

const UserBottomNav = () => {
  const { totals } = useCart(); 
  const totalQty = totals?.totalQty || 0;

  const linkClass = ({ isActive }) =>
    `flex flex-col items-center gap-1 text-xs transition-colors ${
      isActive ? "text-black" : "text-gray-700"
    }`;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 bg-white border-t md:hidden">
      <div className="relative max-w-9xl mx-auto flex justify-around py-2">
        {bottomNavRoutes.map(({ label, path, icon: Icon, isCart }) => (
          <NavLink key={path} to={path} className={linkClass}>
            <div className="relative">
              <Icon size={22} />

              {/* Cart badge */}
              {isCart && totalQty > 0 && (
                <span
                  className="
                    absolute -top-1.5 -right-2
                    min-w-[16px] h-4 px-1
                    rounded-full
                    bg-[#f0653a]
                    text-white
                    text-[10px]
                    flex items-center justify-center
                  "
                >
                  {totalQty}
                </span>
              )}
            </div>

            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default UserBottomNav;
